/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Rule_SubpagesInputs */

const en_directory_submit_rule_subpages = /** @type {(inputs: Directory_Submit_Rule_SubpagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One listing per product. Do not submit separate pages from the same root domain, such as a blog, pricing page, or feature page.`)
};

const zh_directory_submit_rule_subpages = /** @type {(inputs: Directory_Submit_Rule_SubpagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同一产品只保留一个条目。不要重复提交同一根域名下的博客、定价页或功能页等子页面。`)
};

/**
* | output |
* | --- |
* | "One listing per product. Do not submit separate pages from the same root domain, such as a blog, pricing page, or feature page." |
*
* @param {Directory_Submit_Rule_SubpagesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_rule_subpages = /** @type {((inputs?: Directory_Submit_Rule_SubpagesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Rule_SubpagesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_rule_subpages(inputs)
	return zh_directory_submit_rule_subpages(inputs)
});
export { directory_submit_rule_subpages as "directory.submit.rule_subpages" }